<template>
  <div>
    <div
      ref="dropzone"
      id="dropzone"
      class="h-64 w-full bg-base-200 border border-dashed border-base-content/30 flex justify-center items-center"
      :class="{ dragover: dropzoneDragOver }"
    >
      <div class="inline-block">
        Drop files here or click to select...
        <div v-if="fileList.length > 0">
          {{ fileList.length }} files selected.
          <a href="#" @click.prevent.stop="fileList = []">Clear all</a>
        </div>
      </div>
    </div>
    <div v-if="fileError" class="mt-2 text-sm text-error">
      {{ fileError }}
    </div>
    <button
      type="button"
      class="btn btn-success my-5"
      @click="loadFiles"
      v-if="fileList.length > 0 && caseDef.studies.length === 0"
      :disabled="loading"
    >
      {{
        loading ? "Loading..." : `Load file${fileList.length > 1 ? "s" : ""}`
      }}
    </button>
  </div>
  <!-- <input type="file" ref="fileSelectInput" id="input-files" class="mb-5" multiple /> -->
  <!-- <div>
                  <a href="#" @click.prevent="showImportByUrl = !showImportByUrl" class="text-sm"
                    >Import by URL</a
                  >
                  <input
                    v-show="showImportByUrl"
                    type="text"
                    ref="fileUrlInput"
                    id="test-file"
                    placeholder="/dicom/CT1_J2KR"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                  />
                </div> -->
</template>

<script setup lang="ts">
import Dropzone, { type DropzoneFile } from "dropzone";
import { onMounted, ref } from "vue";
import CaseDef from "../../types/CaseDef";

defineProps<{ caseDef: CaseDef; loading?: boolean }>();
const emit = defineEmits(["load-files"]);

const fileList = ref<File[]>([]);
const dropzoneDragOver = ref(false);
const fileError = ref("");

onMounted(() => {
  // Dropzone
  const dropzone = new Dropzone("#dropzone", {
    url: "/",
    autoProcessQueue: false,
    autoQueue: false,
    // Dropzone defaults maxFilesize to 256 MB and rejects larger files before our
    // accept() below ever runs. Raise to 2 GB; oversized files are surfaced via the
    // 'error' handler below (with previews disabled there's no built-in error UI).
    maxFilesize: 2048, // MB
    // @ts-ignore: option not in dropzone types, but documented and works?
    disablePreviews: true,
    accept(file: File, done: any) {
      fileError.value = "";
      fileList.value.push(file);
      done();
    },
  });
  dropzone.on("dragover", () => {
    dropzoneDragOver.value = true;
  });
  dropzone.on("dragleave", () => {
    dropzoneDragOver.value = false;
  });
  // Surface rejected files (e.g. over maxFilesize) instead of failing silently.
  dropzone.on("error", (file: DropzoneFile, message: string) => {
    fileError.value = message || `Could not add "${file.name}".`;
    // Drop the errored file from dropzone's internal list so it doesn't linger.
    dropzone.removeFile(file);
  });
  // Doing this instead of keeping a reference to the dropzone object because for some reason after
  // minification, other references to the dropzone object turn into just the HTML element so none
  // of the functions are defined...??? Must be some side effect of `script setup` or reactivity.
  // This works well enough.
  document.addEventListener("clear-dropzone", () => {
    console.log("clearing dropzone");
    dropzone.removeAllFiles();
  });
});

function loadFiles() {
  emit("load-files", fileList.value);
  document.dispatchEvent(new Event("clear-dropzone"));
}
</script>

<style scoped>
#dropzone.dragover {
  background-color: color-mix(in oklab, var(--color-success) 15%, transparent);
}
</style>
